import { rule } from '../../domain/badge-composition-rule.js';

/**
 * @param {BadgeComposition} composition
 * @returns {BadgeCompositionRule[]}
 */
export const horizontalRules = composition => {
  const { platformIs, variantIs, planIs, planIsAtLeast, positionLocationHIs, aspectTypeIs, featureIsEnabled } = composition.checkers;

  return [
    // flag to be used for style adjustments
    rule('horizontal-custom/free/adjustments')
      .when(platformIs('desktop'))
      .when(variantIs('mid'))
      .set(() => ({
        flags: {
          [`horizontal-${composition.aspect.position.horizontal.location}`]: true
        }
      })),

    // horizontal left or custom position for free => no shake, and only show seal, as on mobile
    rule('horizontal-custom/free/adjustments')
      .when(platformIs('desktop'))
      .when(variantIs('mid'))
      .when(positionLocationHIs('custom'))
      .when(planIs('free'))
      .when(aspectTypeIs('collapsed'))
      .set(() => ({
        constraints: {
          hideContainerWhenMinimized: true,
        },
        parts: {
          sealAsButton: {
            show: true,
            includeBottomText: 'normal'
          }
        }
      })),

    // horizontal custom position for start/premium => all edges rounded
    rule('horizontal-custom/start+/adjustments')
      .when(platformIs('desktop'))
      .when(variantIs('mid'))
      .when(planIsAtLeast('start'))
      .set(() => ({
        container: {
          type: 'round-rectangle',
        },
      }))
  ];
};
